'use strict';
import { react2angular } from 'react2angular';
import InvoiceExportManagementWrapper from '../../src/views/invoice-details/components/invoice-export-management/InvoiceExportManagementWrapper';

angular
    .module('dstreamApp.reactBridge')
    .component('dsInvoiceExportManagement', react2angular(InvoiceExportManagementWrapper, ['invoice', 'reloadInvoiceData', 'setInvoiceExportAfterApproval']));
